import React from 'react';
import PremiumPricingGuide from '../containers/PremiumPricingGuide';

export default (props) => (
  <PremiumPricingGuide {...props} />
);
